/**
 * Models an admin account object to be used in a form
 */

import Account from "./account";
import Roles from "../../collections/account-roles";

const Model = Account.extend({
  namedAttributes: {
    roles: Roles,
  },
});

export { Model as default };
